import React from 'react';
import PanelInformationItem from "../../Atoms/Items/PanelInformationItem";
import EmployeeInformationContainer from "../Containers/EmployeeInformationContainer";

const PaymentDataPanel = () => {
  return (
    <EmployeeInformationContainer
      title="Datos de pago"
      icon="cash"
    >
      <PanelInformationItem title="Método de pago" text="Transferencia" />
      <PanelInformationItem title="Banco" text="BBVA Colombia" />
      <PanelInformationItem title="Tipo de cuenta" text="Crédito" />
      <PanelInformationItem title="No. de cuenta" text="54 4532 4321" />
    </EmployeeInformationContainer>
  );
};

export default PaymentDataPanel;
